export default __webpack_public_path__ + "static/media/polytech.b3c23512.png";